
import { defineComponent } from 'vue'

import AddTeamToGroupMixin from '~/mixins/addTeamToGroupMixin'
import { resolveNodes } from '~/utils/array'
import { formatDate, parseISODate } from '~/utils/date'
import { getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'ControlPanelAddTeamToGroupModal',
  props: {
    groupId: {
      type: String,
      required: true
    }
  },
  mixins: [AddTeamToGroupMixin],
  data() {
    return {
      showAddTeamModal: false,
      addTeamSearchCandidate: '',
      refetch: false
    }
  },
  computed: {
    teamsToAdd() {
      return resolveNodes(this.groupTeamsToAdd.allTeams)
    }
  },
  async fetch(): Promise<void> {
    await this.fetchTeamsToAdd({
      groupId: this.groupId,
      q: this.addTeamSearchCandidate,
      refetch: this.refetch
    })
  },
  methods: {
    parseISODate,
    getDefaultAvatar,
    formatDate,
    showModal(): void {
      this.showAddTeamModal = true
    },
    searchTeams(teamName: string): void {
      this.addTeamSearchCandidate = teamName
      this.$fetch()
    }
  },
  watch: {
    groupId: {
      immediate: true,
      handler(): void {
        if (process.client) {
          this.addTeamSearchCandidate = ''
          this.refetch = true
          this.$fetch()
        }
      }
    }
  }
})
